import {
  GET_RESTAURANT,
  GET_CATALOGS,
  GET_CATEGORIES,
  GET_MENUS,
  TRACK,
  ADD_FEED_LOADER,
} from "../types";

const initialState = {
  restaurantsDetail: {},
  catalogs: [],
  categories: [],
  orderTracker: "",
  catalogLoader: false,
  feedbackLoader: false,
  AllLikedMenu: [],
  userTableInfo: null,
  getLoader: false,
  getLikedLoading: false,
  requestLoading: false,
  fetchLoader: false,
  driverDetail: "",
  menus: [],
  feedLoader: false,
  LikedMenu: [],
  allRestaurants: [],
};

export default function restaurantsReducer(
  state = initialState,
  { type, payload, action }
) {
  switch (type) {
    case "ALL_RESTAURANTS":
      return {
        ...state,
        allRestaurants: payload,
      };
    case GET_RESTAURANT:
      return {
        ...state,
        restaurantsDetail: payload,
      };

    case "GET_LIKED_ITEMS":
      return {
        ...state,
        getLikedLoading: payload,
      };

    case "SET_USER_TABLE_INFO":
      return {
        ...state,
        userTableInfo: payload,
      };

    case "GET_RESTAURANT_LOADER":
      return {
        ...state,
        getLoader: payload,
      };
    case "CATALOG_LOADER":
      return {
        ...state,
        catalogLoader: payload,
      };
    case GET_CATALOGS:
      return {
        ...state,
        catalogs: payload,
      };
    case ADD_FEED_LOADER: {
      return {
        ...state,
        feedLoader: payload,
      };
    }
    case GET_CATEGORIES:
      return {
        ...state,
        categories: payload,
      };
    case TRACK:
      return {
        ...state,
        orderTracker: payload,
      };
    case "DRIVER_DETAIL":
      return {
        ...state,
        driverDetail: payload,
      };
    case "REQUESTLOADING":
      return {
        ...state,
        requestLoading: payload,
      };
    case "FEEDBACK_LOADING":
      return {
        ...state,
        feedbackLoader: payload,
      };
    case "FETCH_LOADER":
      return {
        ...state,
        fetchLoader: payload,
      };
    case GET_MENUS:
      return {
        ...state,
        menus: payload,
      };
    case "LIKED_ITEMS":
      return {
        ...state,
        LikedMenu: payload,
      };
    case "ALL_LIKED_ITEMS":
      return {
        ...state,
        AllLikedMenu: payload,
      };
    default:
      return { ...state };
  }
}
